import { useId, type ReactNode } from 'react';
import './text-field.css';

/** Поле текста общего шаблона: рамка box, счётчик, действие редактора. */
export function TextField({
  label,
  value,
  limit,
  disabled,
  onChange,
  onExpand,
  expandLabel,
  multiline = true,
  children,
  placeholder,
  minimum = 0,
}: {
  label: string;
  value: string;
  limit: number;
  disabled?: boolean;
  onChange(value: string): void;
  onExpand?(): void;
  expandLabel?: string;
  multiline?: boolean;
  children?: ReactNode;
  placeholder?: string;
  minimum?: number;
}) {
  const id = useId();
  const count = Array.from(value).length;
  return (
    <div className={`studio-text-field${multiline ? '' : ' single-line'}`}>
      <div className="box pf-box">
        <div className="top">
          <label className="lb" htmlFor={id}>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M4 20h4l10-10-4-4L4 16zM13 7l4 4" />
            </svg>
            {label}
          </label>
          <span className={`cnt${count > limit ? ' bad' : count >= minimum && count > 0 ? ' ok' : ''}`}>
            {count} / {limit}
          </span>
          {onExpand && (
            <button type="button" className="bx-full" disabled={disabled} aria-label={expandLabel} onClick={onExpand}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true">
                <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" />
              </svg>
            </button>
          )}
        </div>
        {multiline ? (
          <textarea
            id={id}
            value={value}
            maxLength={limit * 2}
            disabled={disabled}
            placeholder={placeholder}
            onChange={event => onChange(Array.from(event.target.value).slice(0, limit).join(''))}
          />
        ) : (
          <input
            id={id}
            value={value}
            maxLength={limit * 2}
            disabled={disabled}
            onChange={event => onChange(Array.from(event.target.value).slice(0, limit).join(''))}
          />
        )}
        {children}
      </div>
    </div>
  );
}
